<template>
  <div class="rc-form-item" :class="[`rc-${status}-form-item`]">
    <!-- 自定义form-item header -->
    <slot :name="slotName('header')" :column="item" :row="formData[item.prop]" />
    <!-- form-item -->
    <el-form-item v-bind="$attrs" :ref="item.prop" :style="item.itemStyle">
      <!-- 自定义form-item label -->
      <template v-if="customLabel" slot="label">
        <slot :name="slotName('label')" :column="item" :row="formData[item.prop]">
          <span :style="item.labelStyle">{{ item.label }}</span>
          <em v-if="item.slotLabel" :style="item.slotStyle">{{ item.slotLabel }}</em>
        </slot>
      </template>

      <!-- 自定义form-item error -->
      <template slot="error" slot-scope="{ error }">
        <slot :name="slotName('error')">
          <div class="rc-form-item-error">
            <i v-if="item.errorIcon" :class="errorIconFun"></i>
            {{error }}
          </div>
        </slot>
      </template>

      <!-- 默认插槽 -->
      <slot>
        <!-- form表单查看 -->
        <span v-if="viewItem(item)" :style="item.contentStyle">{{ viewItemData(item.prop) }}</span>

        <!-- form表单编辑 -->
        <component
          :is="item.component"
          v-else
          v-model="formData[item.prop]"
          v-bind="{ ...item, ...item.attribute }"
          :slot-prefix="item.prop || ''"
          :slots="slots(item)"
          v-on="{ ...$listeners, ...item.events }"
        >
          <template v-for="(index, name) in $scopedSlots" #[name]="slotScope">
            <slot :name="name" v-bind="slotScope"></slot>
          </template>
        </component>
      </slot>
    </el-form-item>
    <slot v-if="showFooter" :name="slotName('footer')" :column="item" :row="formData[item.prop]">
      <div class="rc-form-item-suffix" :style="item.boxStyle">
        <i v-if="item.iconName" :style="item.iStyle" :class="item.iconName" />
        <svg-icon v-if="item.svgIcon" :style="item.svgStyle" :icon-class="item.svgIcon" />
        <img v-if="item.img" :style="item.imgStyle" :src="require(`@/assets/images/${item.img}`)" :alt="item.img" />
        <span v-if="item.descLabel" :style="item.slotStyle">{{ item.descLabel }}</span>
      </div>
    </slot>
  </div>
</template>

<script>
import { componentSlotsMap, componentViewList } from "./config";
import { $upperFirst } from "@/utils/components/helper";
import { registerComponents } from "@/utils/utils";
export default {
  name: "RcFormItem",
  components: {
    ...registerComponents({ fileList: require.context("../RcBase", true, /index\.js$/) })
  },
  props: {
    // 编辑数据
    data: {
      type: Object,
      default: () => {}
    },
    // 查看数据
    viewData: {
      type: Object,
      default: () => {}
    },
    // 状态
    status: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      item: this.$attrs,
      formData: this.data
    };
  },
  watch: {
    data: {
      handler(val) {
        this.formData = val;
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    viewItem() {
      return item => this.status === "view" && !this.isViewComponent(item);
    },
    /**
     * TODO: 根据options回显值逻辑
     * 查看item
     */
    viewItemData() {
      return prop => (this.viewData && this.viewData[prop]) || (this.data && this.data[prop]);
    },
    // 自定义label
    customLabel() {
      // 有自定义label || 查看表单
      return this.item.slotLabel || this.status === "view";
    },
    // 插槽名称
    slotName() {
      return suffix => (this.item.prop ? `${this.item.prop}${$upperFirst(suffix)}` : suffix);
    },
    showFooter() {
      const { iconName, svgIcon, img, descLabel } = this.item;
      return iconName || svgIcon || img || descLabel;
    },
    errorIconFun() {
      const { errorIcon } = this.item;
      const type = typeof errorIcon === "boolean";
      return type ? "el-icon-warning" : errorIcon;
    }
  },
  methods: {
    // 查看类组件
    isViewComponent(item) {
      return componentViewList.includes(item.component);
    },
    // form-item 插槽集合
    slots(item) {
      const { component, prop, slotName } = item;
      const componentSlots = componentSlotsMap[component];

      // 存在slots
      if (componentSlots) {
        const slots = componentSlots.map(slot => (prop ? `${prop}${$upperFirst(slot)}` : slot));
        slotName && slots.push(slotName);
        return slots;
      }

      // 不存在则判断是否添加slot
      if (slotName) {
        return [slotName];
      }

      return [];
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-form-item {
  .rc-form-item-error,.rc-form-item-suffix {
    position: relative;
    top: 100%;
    left: 0;
    padding-top: 8px;
  }
  .rc-form-item-error {
    color: #e60000;
    font-size: 12px;
    line-height: 1;
  }
  .rc-form-item-suffix {
    margin-top: -26px;
    margin-bottom: 26px;
  }
}
// 表单查看
.rc-view-form-item {
  ::v-deep .el-form-item {
    margin-bottom: 0;
    &.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
      content: '';
      margin-right: 0px;
    }
    &  > .el-form-item__label {
      padding: 0 2px 0 0;
    }
  }
}
</style>
